import { render, staticRenderFns } from "./VideoBankEntity.vue?vue&type=template&id=48947060&scoped=true"
import script from "./VideoBankEntity.vue?vue&type=script&lang=js"
export * from "./VideoBankEntity.vue?vue&type=script&lang=js"
import style0 from "./VideoBankEntity.vue?vue&type=style&index=0&id=48947060&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48947060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48947060')) {
      api.createRecord('48947060', component.options)
    } else {
      api.reload('48947060', component.options)
    }
    module.hot.accept("./VideoBankEntity.vue?vue&type=template&id=48947060&scoped=true", function () {
      api.rerender('48947060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VideoBankEntity.vue"
export default component.exports